import { ChunkInspectorAnswerResource as e } from "./answer/ChunkInspectorAnswer.js";
import { ChunkInspectorDocumentResource as t } from "./document/ChunkInspectorDocument.js";
import { ChunkInspectorSearchResource as n } from "./search/ChunkInspectorSearch.js";
import { Resource as r } from "@coveo/platform-client";
//#region src/resources/chunk-inspector/ChunkInspectorResource.ts
var i = class extends r {
	constructor(r, i) {
		super(r, i), this.answer = new e(r, i), this.search = new n(r, i), this.document = new t(r, i);
	}
};
//#endregion
export { i as ChunkInspectorResource };

//# sourceMappingURL=ChunkInspectorResource.js.map